import React from 'react';
import { useTranslation } from 'react-i18next';
import { components, NoticeProps } from 'react-select';
import { Option } from '../types';

export const NoOptionsMessage: React.FC<NoticeProps<Option>> = (props) => {
  const { t } = useTranslation('toBank');
  return (
    <components.NoOptionsMessage {...props}>
      {props.selectProps.inputValue
        ? t('Not found')
        : t('Start typing to see the available options')}
    </components.NoOptionsMessage>
  );
};
